import { render, staticRenderFns } from "./AmazonReportEvent.vue?vue&type=template&id=65df5e64"
import script from "./AmazonReportEvent.vue?vue&type=script&lang=js"
export * from "./AmazonReportEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports